export const sortData = (data, sortConfig) => {
  return [...data].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const aVal = a[sortConfig.key] || '';
    const bVal = b[sortConfig.key] || '';

    // 增強版：同時支援 MM/DD/YYYY 與 DD/MM/YYYY 日期格式解析
    const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})( \d{2}:\d{2}:\d{2})?$/;
    const matchA = String(aVal).match(dateRegex);
    const matchB = String(bVal).match(dateRegex);

    if (matchA && matchB) {
      const parseDate = (match) => {
        let p1 = parseInt(match[1], 10);
        let p2 = parseInt(match[2], 10);
        let y = parseInt(match[3], 10);
        let time = match[4] ? match[4].trim() : '00:00:00';
        
        let m, d;
        if (p1 > 12) {
          d = p1; m = p2;
        } else if (p2 > 12) {
          m = p1; d = p2;
        } else {
          m = p1; d = p2; // 預設為 MM/DD/YYYY
        }
        return new Date(`${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}T${time}`);
      };
      const dateA = parseDate(matchA);
      const dateB = parseDate(matchB);
      if (!isNaN(dateA) && !isNaN(dateB)) {
        return sortConfig.direction === 'asc' ? dateA - dateB : dateB - dateA;
      }
    }

    // 增強版：精準的數字排序 (解決 Ref 10 排在 2 前面的問題，並支援有逗號的金額)
    const cleanA = String(aVal).replace(/,/g, '').trim();
    const cleanB = String(bVal).replace(/,/g, '').trim();
    const isNumericA = cleanA !== '' && !isNaN(cleanA);
    const isNumericB = cleanB !== '' && !isNaN(cleanB);

    if (isNumericA && isNumericB) {
      return sortConfig.direction === 'asc' ? parseFloat(cleanA) - parseFloat(cleanB) : parseFloat(cleanB) - parseFloat(cleanA);
    }

    // 字串比較
    return sortConfig.direction === 'asc'
      ? String(aVal).localeCompare(String(bVal))
      : String(bVal).localeCompare(String(aVal));
  });
};

export const getNextStatus = (currentStatus, options) => {
  const currentIndex = options.indexOf(currentStatus);
  if (currentIndex === -1) return options[0];
  return options[(currentIndex + 1) % options.length];
};